
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.507 2.5c.456 0 .826.37.826.828v13.344c0 .457-.38.828-.826.828H2.493a.827.827 0 01-.826-.828V3.328c0-.457.379-.828.826-.828h15.014zm-.84 1.667H3.332v11.666h13.333V4.167zM15 12.5v1.667H5V12.5h10zm-5-6.667v5H5v-5h5zm5 3.334v1.666h-3.334V9.167H15zM8.333 7.5H6.666v1.667h1.667V7.5zM15 5.833V7.5h-3.334V5.833H15z","fill":"#910000"}})])
          )
        }
      }
    